import { Text } from '@elkaso-app/web-design';
import type { DealCategoryTreeNode } from 'apis/exclusive-deals';
import { findCategoryPath } from 'pages/exclusive-deals/components/editable-deals-grid/category-tree-helpers';

export interface IFamilyCategoryCell {
  catalogCategoryId: number;
  categoryTree: DealCategoryTreeNode[];
  noOfLines?: number;
}

export const FamilyCategoryCell = ({ catalogCategoryId, categoryTree, noOfLines }: IFamilyCategoryCell) => {
  const path = findCategoryPath(categoryTree, catalogCategoryId);
  const label = path.length ? path.map((n) => n.title || `Untitled (${n.id})`).join(' › ') : `#${catalogCategoryId}`;

  return (
    <Text fontSize='sm' color='gray.700' noOfLines={noOfLines}>
      {label}
    </Text>
  );
};
